import { useEffect, FunctionComponent, ReactElement } from 'react'

import { useDispatch } from 'react-redux'
import connect from 'front-end-core/decorators/connect'
import { EncryptionKeysLoaded } from 'front-end-core/services/EncryptionService'
import { mapResponse } from 'front-end-core/helpers/dataflow'
import { combineLatest } from 'rxjs' 
import  { map } from 'rxjs/operators'

import { USERS } from 'constants/requests'
import { $isLogged, User, UserUrn } from 'services/SessionService'
import { fetch } from 'services/ApiService'
import {
  setUserIsLogged,
  setUserDetails,
  setUserRoles,
  setUserEncryptionKeysLoaded,
  setAllUsers,
  setUserUrn
} from 'redux/actions'
import ResponseConsumer from './shared/ResponseConsumer'

const UserWrapper:FunctionComponent<UserWrapperProps> = ({
  isLogged,
  userDetails,
  userRoles,
  encryptionKeysLoaded,
  users,
  children
}) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setUserIsLogged(isLogged))
  }, [isLogged, setUserIsLogged])

  useEffect(() => {
    dispatch(setUserDetails(userDetails))
  }, [userDetails, setUserDetails])

  useEffect(() => {
    dispatch(setUserRoles(userRoles))
  }, [userRoles, setUserRoles])

  useEffect(() => {
    dispatch(setUserEncryptionKeysLoaded(encryptionKeysLoaded))
  }, [encryptionKeysLoaded])

  useEffect(() => {
    if (users) {
      const { allUsers, userUrn } = users
      allUsers && dispatch(setAllUsers(allUsers))
      userUrn && dispatch(setUserUrn(userUrn))
    }
  }, [users])

  const renderContent = () => <>{children}</>

  return (
    <ResponseConsumer content={renderContent} pendingComponent={renderContent} />
  )
}

const ConnectedUserWrapper = connect(() => ({
  isLogged: $isLogged.pipe(map(mapResponse(({ isLogged }: {isLogged:boolean}) => isLogged))),
  userDetails: User,
  userRoles: User.pipe(map((userRoles: {roles: string[]}) => userRoles.roles || [])), // FIX ME
  encryptionKeysLoaded: EncryptionKeysLoaded,
  users: combineLatest([
    fetch(USERS),
    UserUrn
  ],
    mapResponse((allUsers:any, userUrn:any) => ({ allUsers, userUrn }))
  )
}))((props:any) => <UserWrapper {...props} />)

interface UserWrapperProps {
  isLogged: boolean;
  userDetails: any;
  userRoles: string[];
  encryptionKeysLoaded: boolean;
  users: {allUsers: any[]; userUrn:string};
  children: ReactElement;
}

export default ConnectedUserWrapper
